/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, { Component } from 'react';
import ModalDialog from "../../../widgets/ModalDialog/ModalDialogLink";
import AddNoteModal from "./AddNoteModal";
import PropTypes from "prop-types";
import Moment from 'moment';
import {MESSAGES, PERMISSIONS} from '../../../../constants/APP_CONSTANTS';
import UserPermissionSingleton from '../../../../_helpers/UserPermissionSingleton';

export default class Notes extends Component {
    static get propTypes() {
        return {
            notes: PropTypes.array,
            holds: PropTypes.array,
            saveNotes: PropTypes.func,
            activeCollection: PropTypes.object,
        };
    }
    constructor (props) {
        super(props);
        this.state = {
            notes: this.props.notes,
            currentDateTime: Moment.utc(new Date()).local().format("MM-DD-YYYY HH:mm:ss")
        };

    }
    componentWillReceiveProps(nextProps) {

    }
    render() {

        let noteCount = this.props.notes ? this.props.notes.length : 0;
        noteCount = this.props.activeCollection && this.props.activeCollection.hasOMResources ? noteCount + 1  : noteCount;
        noteCount = this.props.activeCollection && this.props.activeCollection.has3PResources ? noteCount + 1: noteCount;
        console.dir(noteCount);
        return (
            <div className="notes-container">
                <label id="total-notes">{noteCount ? (noteCount === 1 ? "1 Note" : noteCount+ " Notes"): "0 Note" }</label>
                {!UserPermissionSingleton.hasPermission(PERMISSIONS. view_only_add_notes) && <ModalDialog
                    trigger={<a href="#" className="add-note">Add note<i className="plus-icon fa fa-plus-circle"/></a>}
                    title="Digital Collection Notes" >
                    <AddNoteModal activeCollection ={this.props.activeCollection} notes = {this.props.notes}  holds={this.props.holds} saveNotesWithHolds={this.props.saveNotes} />
                </ModalDialog>}
                <div>
                    {
                        <div className="notes">
                            {(this.props.notes && this.props.notes.length > 0) ?
                                <div >
                                    {this.props.notes.map((notes) =>
                                        <div className="note" >
                                            <span className="left-cell"> <b>{Moment.utc(notes.createdTimestamp).local().format("MM-DD-YYYY HH:mm:ss") + " "
                                            } [{notes.userFirstName}] : </b></span><div className="right-cell">{
                                                notes.collectionNoteHolds && notes.collectionNoteHolds.length > 0 && notes.collectionNoteHolds.map((holds) =>{
                                                    return  <span className={(holds.selected) ? 'tableBox orangeBox' : 'tableBox'} >{holds.hold}</span>;
                                                })
                                            } <span id= "note" className="noteBody">{notes.body}  </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                : null}

                            {
                                (this.props.activeCollection && this.props.activeCollection.hasOMResources) && <div className="note" >
                                    <span className="left-cell"><b>{ this.state.currentDateTime + " "
                                    } : </b></span><div className="right-cell">
                                        <span id= "note" className="noteBody">{MESSAGES['book_has_om']}  </span></div>
                                </div>
                            }

                            {
                                (this.props.activeCollection && this.props.activeCollection.has3PResources) && <div className="note" >
                                    <span className="left-cell"><b> this.state.currentDateTime + " "
                                    } : </b></span><div className="right-cell">
                                        <span id= "note" className="noteBody">{MESSAGES['book_has_3p']}  </span></div>
                                </div>
                            }

                        </div>
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookDetailsComponents/Notes.js